import { motion } from "framer-motion";
import { WHATSAPP_DEFAULT_MESSAGE } from "@/config/siteConfig";
import { waLink, trackEvent } from "@/lib/whatsapp";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const FloatingWhatsApp = () => (
  <motion.a
    href={waLink(WHATSAPP_DEFAULT_MESSAGE)}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackEvent("clic_whatsapp", { source: "bouton_flottant" })}
    data-testid="floating-whatsapp-button"
    aria-label="Discuter avec un conseiller sur WhatsApp"
    initial={{ opacity: 0, scale: 0.6 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ delay: 1.6, duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-5 right-5 z-50 flex h-15 w-15 items-center justify-center rounded-full bg-[#25D366] text-white shadow-2xl transition-transform duration-300 hover:scale-110 md:bottom-6 md:right-6"
    style={{ height: 60, width: 60 }}
  >
    <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/50" style={{ animationDuration: "2.2s" }} />
    <WhatsAppIcon className="h-8 w-8" />
  </motion.a>
);
